document.addEventListener('DOMContentLoaded', function() {
    // Target only links that end with "-modal"
    var modalLinks = document.querySelectorAll('a[href*="-modal"]');

    // Default modal behavior
    modalLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            var modalId = link.getAttribute('href').substring(1);
            var modal = document.getElementById(modalId);
            if (modal) modal.style.display = 'block';
        });
    });

    // Special-case override (run AFTER default so it wins)
    document.querySelectorAll('a.switch-modal').forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();

            // Close all modals
            document.querySelectorAll('.overlay').forEach(function(overlay) {
                overlay.style.display = 'none';
            });

            // Open the target modal
            var modalId = link.getAttribute('href').substring(1);
            var modal = document.getElementById(modalId);
            if (modal) modal.style.display = 'block';
        });
    });

    // Close buttons
    document.querySelectorAll('.close').forEach(function(closeBtn) {
        closeBtn.addEventListener('click', function() {
            var modal = closeBtn.closest('.overlay');
            if (modal) modal.style.display = 'none';
        });
    });

    // Close on clicking outside
    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('overlay')) {
            event.target.style.display = 'none';
        }
    });
});